// import React, { useEffect, useState } from "react";
// import * as _ from "lodash"
// import { Table, Button, Form, Tabs, Tab } from "react-bootstrap";
// import AnimationLoading from "../../../components/AnimationLoading";
// import { useLazyQuery } from "@apollo/client";
// import moment from "moment";
// import { imageRender } from "../../../helpers";
// import { COLOR_APP } from "../../../constants";
// import { GET_LIVE_STOCKS } from "../../../graphql/liveStock/query";

// function LiveDetailLiveStock({ liveData }) {
//     const LIMIT_PAGE = 30;

//     const [liveStocks, setLiveStocks] = useState([]);
//     const [liveStocksTotal, setLiveStocksTotal] = useState(0);
//     const [pageNumber, setPageNumber] = useState(1);
//     const [pageCountNumber, setPageCountNumber] = useState(1);
//     const [isLoading, setIsLoading] = useState(false);

//     const [getLiveStocks, { data: liveStockData, loading: liveStockLoading }] = useLazyQuery(GET_LIVE_STOCKS, { fetchPolicy: "cache-and-network" });

//     useEffect(() => {
//         if (liveData?.id) {
//             const fetch = async () => {
//                 getLiveStocks({
//                     variables: {
//                         where: {
//                             live: liveData?.id
//                         },
//                         limit: LIMIT_PAGE,
//                         skip: LIMIT_PAGE * (pageNumber - 1),
//                         orderBy: "createdAt_DESC"
//                     }
//                 })
//             }
//             fetch();
//         }
//     }, [liveData])

//     useEffect(() => {
//         // console.log("liveStockData?.liveStocks: ", liveStockData?.liveStocks);
//         if (liveStockData?.liveStocks) {
//             setLiveStocks(liveStockData?.liveStocks?.data)
//             setLiveStocksTotal(liveStockData?.liveStocks?.total)
//             setPageCountNumber(parseInt(liveStockData?.liveStocks?.total / LIMIT_PAGE) + 1)
//         }
//     }, [liveStockData])

//     useEffect(() => {
//         onNextOrBackPage();
//     }, [pageNumber])

//     const onNextOrBackPage = async () => {
//         try {
//             setIsLoading(true)
//             await getLiveStocks({
//                 variables: {
//                     where: {
//                         live: liveData?.id
//                     },
//                     limit: LIMIT_PAGE,
//                     skip: LIMIT_PAGE * (pageNumber - 1),
//                     orderBy: "createdAt_DESC"
//                 }
//             })
//             setIsLoading(false)
//         } catch (error) {
//             setIsLoading(false)
//             console.log("error: ", error)
//         }
//     }

//     const onNextPage = () => {
//         setPageNumber(parseInt(pageNumber) != parseInt(pageCountNumber) ? parseInt(pageNumber) + 1 : parseInt(pageCountNumber))
//     }

//     const onBackPage = () => {
//         setPageNumber(parseInt(pageNumber) != 1 ? parseInt(pageNumber) - 1 : 1)
//     }

//     const onChoosePage = (page) => {
//         setPageNumber(parseInt(page))
//     }

//     if(liveStockLoading) return <AnimationLoading />

//     return (
//         <div>
//             {/* {liveStockLoading ? <AnimationLoading /> : <div />} */}
//             <p style={{ fontSize: 20, margin: 0 }}>ລາຍການສິນຄ້າທີ່ເພີ່ມເຂົ້າໃນໄລຟ ({liveStocksTotal ?? 0})</p>
//             <div>
//                 <Table responsive className="staff-table-list borderless table-hover">
//                     <thead style={{ background: "#F1F1F1" }}>
//                         <tr>
//                             <th style={{ width: 35 }}>ລຳດັບ</th>
//                             <th style={{ width: 50 }}>ສິນຄ້າ</th>
//                             <th></th>
//                             <th>ລະຫັດ CF</th>
//                             <th>ລາຄາ</th>
//                             <th style={{ width: 150 }}>ຈຳນວນ</th>
//                             <th style={{ width: 170 }}>ສະຖານະ</th>
//                             <th style={{ width: 220 }}>ເວລາ</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {liveStocks?.length > 0 &&
//                             liveStocks?.map((data, index) => (
//                                 <tr key={index}>
//                                     <td style={{ width: 35 }}>{(LIMIT_PAGE * (pageNumber - 1)) + index + 1}</td>
//                                     <td style={{ width: 50 }}><img src={imageRender(data?.stock?.image ?? "")} style={{ borderRadius: "10%", cursor: 'pointer', height: 40, width: 40 }} /></td>
//                                     <td>
//                                         <div>
//                                             {data?.stock?.name || "ຍັງບໍ່ກໍານົດ"}
//                                             {data?.stock?.optionValues.length > 0 &&
//                                                 data?.stock?.optionValues?.map((optionvalue, optionvalueIndex) => (
//                                                     <span key={optionvalueIndex}>{" \t "} {optionvalue?.value} {" "}</span>
//                                                 ))}
//                                         </div>
//                                     </td>
//                                     <td>{data?.cfMessage ?? ""}</td>
//                                     <td>{data?.stock?.price ? new Intl.NumberFormat('en-US').format(data?.stock?.price ?? 0) : "-"} {data?.stock?.currency ?? ""}</td>
//                                     <td style={{ width: 150 }}>{data?.amount ? new Intl.NumberFormat('en-US').format(data?.amount ?? 0) : "0"} / {data?.amountAll ? new Intl.NumberFormat('en-US').format(data?.amountAll ?? 0) : "0"}</td>
//                                     <td style={{ width: 170 }}>
//                                         <span style={{ border: "1px solid " + (data?.isPublished ? "green" : "#eee"), color: data?.isPublished ? "green" : "grey", borderRadius: 20, paddingLeft: 12, paddingRight: 12, paddingTop: 4, paddingBottom: 4 }}>
//                                             {data?.isPublished ? "ເປີດໃຊ້ງານ" : "ປິດໃຊ້ງານ"}
//                                         </span>
//                                     </td>
//                                     <td style={{ width: 220 }}>{moment(data?.createdAt).format('DD/MM/YYYY HH:mm A')}</td>
//                                 </tr>
//                             ))}
//                     </tbody>
//                 </Table>
//                 {(pageCountNumber && liveStocks.length > 0) &&
//                     <div className="text-center" style={{ display: "flex", justifyContent: "center" }}>
//                         <nav aria-label="Page navigation example">
//                             <ul className="pagination">
//                                 <li className="page-item" onClick={() => onBackPage()} style={{ cursor: "pointer" }}><a className="page-link">ກັບຄືນ</a></li>
//                                 {Array.from(Array(pageCountNumber), (e, i) => <li className={`page-item ${pageNumber == (i + 1) ? "active" : ""}`} key={i} style={{ cursor: "pointer" }} onClick={() => onChoosePage(i + 1)}><a className="page-link" >{i + 1}</a></li>)}
//                                 <li className="page-item" onClick={() => onNextPage()} style={{ cursor: "pointer" }}><a className="page-link">ຕໍ່ໄປ</a></li>
//                             </ul>
//                         </nav>
//                     </div>
//                 }
//             </div>
//         </div >
//     );
// }

// export default LiveDetailLiveStock;


import React, { useEffect, useState } from "react";
import * as _ from "lodash"
import { Form, Table } from "react-bootstrap";
import AnimationLoading from "../../../components/AnimationLoading";
import { useLazyQuery } from "@apollo/client";
import moment from "moment";
import { imageRender } from "../../../helpers";
import { GET_LIVE_STOCKS } from "../../../graphql/liveStock/query";
import ReactPaginate from "react-paginate";

function LiveDetailLiveStock({ liveData, setLiveStocksNew, setPostStocksTotalNew }) {
    const LIMIT_PAGE = 30;
    const [liveStocks, setPostStocks] = useState([]);
    const [liveStocksTotal, setPostStocksTotal] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCountNumber, setPageCountNumber] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [searchKeyWord, setSearchKeyWord] = useState('');

    const [getLiveStocks, { data: liveStockData }] = useLazyQuery(GET_LIVE_STOCKS, { fetchPolicy: "cache-and-network" });

    useEffect(() => {
        if (liveData?.id) {
            fetch();
        }
    }, [liveData])

    useEffect(() => {
        if (liveStockData?.liveStocks) {
            setPostStocks(liveStockData?.liveStocks?.data)
            setLiveStocksNew(liveStockData?.liveStocks?.data)
            setPostStocksTotalNew(liveStockData?.liveStocks?.total)
            setPostStocksTotal(liveStockData?.liveStocks?.total)
            setPageCountNumber(parseInt(liveStockData?.liveStocks?.total / LIMIT_PAGE) + 1)
        }
    }, [liveStockData])

    useEffect(() => {
        fetch();
    }, [searchKeyWord, pageNumber])
 

    const fetch = async () => {
        try {
            let _where = {
                live: liveData?.id,
                isDeleted: false
            };

            if (searchKeyWord != '') _where = { ..._where, searchKeyWord }

            await getLiveStocks({
                variables: {
                    where: _where,
                    limit: LIMIT_PAGE,
                    skip: (pageNumber - 1) * LIMIT_PAGE,
                    orderBy: "createdAt_DESC"
                }
            });
            return;
        } catch (err) {
            console.log(err)
        }
    }

    const onNextOrBackPage = async () => {
        try {
            setIsLoading(true)
            await getLiveStocks({
                variables: {
                    where: {
                        live: liveData?.id,
                        isDeleted: false
                    },
                    limit: LIMIT_PAGE,
                    skip: LIMIT_PAGE * (pageNumber - 1),
                    orderBy: "createdAt_DESC"
                }
            })
            setIsLoading(false)
            return;
        } catch (error) {
            setIsLoading(false)
            console.log("error: ", error)
        }
    }

    const onNextPage = () => {
        setPageNumber(parseInt(pageNumber) != parseInt(pageCountNumber) ? parseInt(pageNumber) + 1 : parseInt(pageCountNumber))
    }

    const onBackPage = () => {
        setPageNumber(parseInt(pageNumber) != 1 ? parseInt(pageNumber) - 1 : 1)
    }

    const onChoosePage = (page) => {
        setPageNumber(parseInt(page))
    }

    const thousand = num => num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0";

    return (
        <div>
            {isLoading ? <AnimationLoading /> : <div />}
            <div style={{ display: "flex", flexDirection: "row", width: "100%", marginTop: 8, marginBottom: 2 }}>
                <p style={{ fontSize: 20, margin: "10px 0px" }}>ລາຍການສິນຄ້າທີ່ເພີ່ມເຂົ້າໃນໄລຟ ({liveStocksTotal ?? 0})</p>
            </div>
            <Form.Control
                className="mb-2"
                type="text"
                name="searchKeyWord"
                placeholder="ຄົ້ນຫາຕາມຊື່ສິນຄ້າ ຫລື ລະຫັດ CF..."
                value={searchKeyWord}
                onChange={(e) => setSearchKeyWord(e.target.value)}
            />
            <div>
                <Table responsive className="staff-table-list borderless table-hover">
                    <thead style={{ background: "#F1F1F1" }}>
                        <tr style={{ whiteSpace: 'nowrap' }}>
                            <th style={{ width: 35, borderBottom: "none" }}>ລຳດັບ</th>
                            <th style={{ borderBottom: "none" }}>ຮູບ</th>
                            <th style={{ borderBottom: "none" }}>ສິນຄ້າ</th>
                            <th style={{ borderBottom: "none" }}>ລະຫັດ CF</th>
                            <th style={{ borderBottom: "none" }}>ລາຄາ</th>
                            <th style={{ width: 180, borderBottom: "none", alignItems: "center" }}>ຈຳນວນ</th>
                            <th style={{ width: 200, borderBottom: "none" }}>ເວລາ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {liveStocks?.length > 0 &&
                            liveStocks?.map((data, index) => (
                                <tr key={index}>
                                    <td style={{ width: 35 }}>{(LIMIT_PAGE * (pageNumber - 1)) + index + 1}</td>
                                    <td ><img src={imageRender(data?.stock?.image ?? "")} style={{ borderRadius: "10%", cursor: 'pointer', height: 40, width: 40 }} /></td>
                                    <td>
                                        <div>
                                            {data?.stock?.name || "ຍັງບໍ່ກໍານົດ"}
                                            {data?.stock?.optionValues.length > 0 &&
                                                data?.stock?.optionValues?.map((optionvalue, optionvalueIndex) => (
                                                    <span key={optionvalueIndex}>{" \t "} {optionvalue?.value} {" "}</span>
                                                ))}
                                        </div>
                                    </td>
                                    <td>{data?.cfMessage ?? ""}</td>
                                    <td>{data?.stock?.price ? new Intl.NumberFormat('en-US').format(data?.stock?.price ?? 0) : "-"} {data?.stock?.currency ?? ""}</td>
                                    <td>
                                        {thousand(data?.amount > 0 ? data?.amount : 0)} {" / "} {thousand(data?.amountAll > 0 ? data?.amountAll : 0)}
                                    </td>
                                    <td style={{ width: 200 }}>{moment(data?.createdAt).format('DD/MM/YYYY HH:mm A')}</td>

                                </tr>
                            ))}
                    </tbody>
                </Table>
                {(liveStocks.length > 0) &&
                    <ReactPaginate
                        previousLabel="ກັບຄືນ"
                        onPageChange={(e) => setPageNumber(e.selected + 1)}
                        breakLabel="..."
                        pageRangeDisplayed={2}
                        pageCount={Math.ceil(liveStocksTotal / LIMIT_PAGE)}
                        // pageRangeDisplayed={7}
                        marginPagesDisplayed={2}
                        renderOnZeroPageCount={null}
                        containerClassName={"pagination justify-content-center"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        previousClassName={"page-item"}
                        previousLinkClassName={"page-link"}
                        nextClassName={"page-item"}
                        nextLinkClassName={"page-link"}
                        breakClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                        activeClassName={"active"}
                        forcePage={pageNumber - 1}
                        nextLabel="ຕໍ່ໄປ"
                    />
                    // <div className="text-center" style={{ display: "flex", justifyContent: "center" }}>
                    //     <nav aria-label="Page navigation example">
                    //         <ul className="pagination">
                    //             <li className="page-item" onClick={() => onBackPage()} style={{ cursor: "pointer" }}><a className="page-link">ກັບຄືນ</a></li>
                    //             {Array.from(Array(pageCountNumber), (e, i) => <li className={`page-item ${pageNumber == (i + 1) ? "active" : ""}`} key={i} style={{ cursor: "pointer" }} onClick={() => onChoosePage(i + 1)}><a className="page-link" >{i + 1}</a></li>)}
                    //             <li className="page-item" onClick={() => onNextPage()} style={{ cursor: "pointer" }}><a className="page-link">ຕໍ່ໄປ</a></li>
                    //         </ul>
                    //     </nav>
                    // </div>
                }
            </div>
        </div>
    );
}

export default LiveDetailLiveStock;